import { render, staticRenderFns } from "./RecommendCourseFlexCard.vue?vue&type=template&id=46af7778&"
import script from "./RecommendCourseFlexCard.vue?vue&type=script&lang=ts&"
export * from "./RecommendCourseFlexCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports